import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  See sooduskood on kehtetu.

  <span style="color:#85c1dc;">**FI:**</span>
  Alennuskoodi on virheellinen.

  <span style="color:#85c1dc;">**RU:**</span>
  Этот код скидки недействителен.
*/
/* @__NO_SIDE_EFFECTS__ */
const m571 = msg(
  mf`See sooduskood on kehtetu.`,
  mf`Alennuskoodi on virheellinen.`,
  mf`Этот код скидки недействителен.`,
)

export { m571 as 'w.basket.summary.voucher_error' }